module.exports = __webpack_public_path__ + "img/tencent.1fd7df1c.jpg";